import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { progressActions } from '../../progress/actions/progress.actions';
import { userActions } from '../actions/user.actions';

@Injectable()
export class User_ProgressBridge {
    private readonly actions = inject(Actions);

    getLibrary$ = createEffect(() => {
        return this.actions.pipe(
            ofType(userActions.getUserSuccess),
            map(() => progressActions.getProgress()),
        );
    });
}
